// extracted by mini-css-extract-plugin
module.exports = {"pageHeading":"PageHeading_pageHeading___Wp7I","pageHeading_plain":"PageHeading_pageHeading_plain__4SNek","pageHeading__txt":"PageHeading_pageHeading__txt__OgnU8"};